<ng-container *ngIf="!horizontalAlign">
  <ng-container *ngFor="let v of values">
    <div class="row col-12 chk-margin">
      <div class="ui-g-12"><p-checkbox name="group1" [value]="v" [label]="v[labelName]" [(ngModel)]="selectedValues"></p-checkbox></div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="horizontalAlign">
  <div class="d-flex">
    <ng-container *ngFor="let v of values">
      <div class="flex-row pe-5">
        <p-checkbox name="group1" [value]="v" [label]="v[labelName]" [(ngModel)]="selectedValues"></p-checkbox>
      </div>
    </ng-container>
  </div>
</ng-container>
